import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Skeleton, message, Typography, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { useAdvertDetails } from '../../hooks/useAdvertDetails'
import { UserAuth } from '../../../middleware/UserContext/UserContext.middleware'
import AdvertInfo from '../../components/AdvertInfo/AdvertInfo.component'
import BackButton from '../../components/BackButton'
import './AdvertPage.styles.css'

const { Title } = Typography;

type TAdvertPageProps = {
  advertUUID: string
}

const AdvertPage: React.FC<TAdvertPageProps> = ({ advertUUID }) => {
  const navigate = useNavigate()
  const { currentUser } = UserAuth()
  const { t } = useTranslation();
  
  const modern = useAdvertDetails(currentUser, advertUUID);
  const advert = modern.advert;
  const loading = modern.loading;
  const error = modern.error ? new Error(modern.error) : null;
  const deleteAdvert = modern.deleteAdvert;

  const handleAdvertEditClick = () => {
    if (advert) {
      navigate(`/adverts/${advertUUID}/edit`, { state: { advert } })
    }
  }

  const handleAdvertDeleteClick = async () => {
    try {
      if (!advert) {
        message.error(t('advert-not-found', { ns: 'errors' }));
        return;
      }
      const success = await deleteAdvert(advert?.uuid);
      if (success) {
        navigate('/adverts');
        message.success(t('advert-deleted', { ns: 'messages' }));
      }
    } catch (err) {
      message.error(t('delete-error', { ns: 'errors' }));
    }
  }

  if (error) {
    return <div>{t('error', { ns: 'errors' })}: {error.message}</div>
  }

  return (
    <div className="advert_page">
      {loading ? (
        <Skeleton active />
      ) : (
        advert && (
          <>
            <div className="advert_page__header">
              <BackButton />
                
              <Space className="advert_page__header-buttons" direction="horizontal"> 
                <Button type="primary" onClick={handleAdvertEditClick}>
                  {t('edit-advert', { ns: 'buttons' })}
                </Button>
                <Button type="primary" danger onClick={handleAdvertDeleteClick}>
                  {t('delete-advert', { ns: 'buttons' })}
                </Button>
              </Space>
            </div>
            <Title level={3} className="advert_page__title" style={{ textAlign: 'center', width: '100%', marginBottom: '24px' }}>
              {t('advert-view', { ns: 'titles' })}
            </Title>
            <AdvertInfo advertModel={advert} />
          </>
        )
      )}
    </div>
  )
}

export default AdvertPage
